import {FilterOp, OrderByDirection} from '@coolcolduk/firebase-util';
import {mapTradeDbToType, Trade, TradeDb} from '@cp/model';
import {QuerySnapshot} from 'firebase/firestore';
import buildFirestoreQuery from '../../helper/firebase/buildFirestoreQuery';
import mapFirestoreDocs from '../../helper/firebase/mapFirestoreDocs';
import type {FirestoreCursor} from '../../types/FirestoreCursor';
import {getTradeCollection} from './getTradeCollection';

export const TRADES_PAGE_SIZE = 10;

export function listTradesQuery(
  uid: string,
  limit?: number,
  sessionId?: string,
  cursor?: FirestoreCursor,
): Promise<QuerySnapshot<Trade, TradeDb>> {
  return buildFirestoreQuery(getTradeCollection(uid), {
    order: {field: 'openedAt', direction: OrderByDirection.DESC},
    ...(sessionId ? {where: {field: 'sessionId', operator: FilterOp.EQUAL, value: sessionId}} : {}),
    ...(cursor ? cursor : {}),
    ...(limit ? {limit} : {}),
  });
}

export default async function listTrades(
  uid: string,
  limit?: number,
  sessionId?: string,
  cursor?: FirestoreCursor,
): Promise<Trade[]> {
  const snapshot = await listTradesQuery(uid, limit, sessionId, cursor);
  return mapFirestoreDocs(snapshot.docs, mapTradeDbToType);
}
